import textModule from "../Text/textDefaultModuleProp.js";
import textModule2 from "../Text/textSecondModuleProp.js";
import videoModule from "../Video/videoDefaultModuleProp.js";

const galleryModule = {
  config: {
    general: {
      moduleBackgroundColor: {
        label: "White Smoke",
        value: "#f5f5f5",
      },
      paddings: {
        top: true,
        bottom: true,
      },
      corners: {
        label: "Round", // or Square
        value: "round", // or square
      },
    },
  },
  modules: [textModule, textModule2, videoModule],
};

export default galleryModule;
